<template>
  <div class="custom-landing-page-content">
    <div class="settings">
      <WechatShareSetting
        v-if="customSetting.show_wechat_share_settings"
        ref="wechatShareSettings"
        :data="customSetting.wechat_share_settings?.wechat_share_config"
        :weChatTipMsgKey="weChatTipMsgKey"
      ></WechatShareSetting>
      <PageSettings
        v-if="customSetting.has_company_webpage_setting"
        ref="pageSettings"
        :customSetting="customSetting"
        :hiddenVideoNavigation="hiddenVideoNavigation"
        :showContentHeadTitle="showContentHeadTitle"
        :showAddText="showAddText"
        :showAddPictureBoard="showAddPictureBoard"
        :hiddenPageMenu="hiddenPageMenu"
        :pageSettingTitleKey="pageSettingTitleKey"
        :jobDescriptionTipKey="jobDescriptionTipKey"
      ></PageSettings>
      <CustomJobFilter
        v-if="customSetting.show_company_custom_job_filter && !hiddenCustomFilter"
        ref="jobFilter"
        :titleI18nKey="titleI18nKey"
        :switchKey="switchKey"
        :orderKey="orderKey"
        :allowOpenFieldCount="allowOpenFieldCount"
        :allowAllField="allowAllField"
        :isJdDisplay="isJdDisplay"
        :jobCustomFieldI18nKey="jobCustomFieldI18nKey"
      ></CustomJobFilter>
      <CustomPageButtonSettings
      v-if="showButtonSettings"
      :switchKey="buttonSwitchKey"
      :titleI18nKey="buttonTitleI18nKey"
      :buttonSettingI18nKey="buttonSettingI18nKey"
      :buttonSettingList="customSetting.company_webpage_setting?.button_items"
      ></CustomPageButtonSettings>
    </div>
  </div>
</template>

<script>
import WechatShareSetting from './wechatShareSetting.vue'
import PageSettings from './pageSettings.vue'
import CustomJobFilter from './customJobFilter.vue'
import CustomPageButtonSettings from './customPageButtonSettings.vue'

export default {
  props: {
    customSetting: {
      type: Object,
      required: true
    },
    // 隐藏视频导览
    hiddenVideoNavigation: {
      type: Boolean,
      default: false
    },
    showContentHeadTitle: {
      type: Boolean,
      default: true
    },
    showAddText: {
      type: Boolean,
      default: true
    },
    showAddPictureBoard: {
      type: Boolean,
      default: true
    },
    weChatTipMsgKey: {
      type: String,
      default: ''
    },
    hiddenPageMenu: {
      type: Boolean,
      default: false
    },
    pageSettingTitleKey: {
      type: String,
      default: ''
    },
    jobDescriptionTipKey: {
      type: String,
      default: ''
    },
    switchKey: {
      type: String,
      default: 'is_used'
    },
    orderKey: {
      type: String,
      default: 'order'
    },
    allowOpenFieldCount: {
      type: String,
      default: '4'
    },
    allowAllField: {
      type: Boolean,
      default: false
    },
    isJdDisplay: {
      type: Boolean,
      default: false
    },
    hiddenCustomFilter: {
      type: Boolean,
      default: false
    },
    titleI18nKey: {
      type: String,
      default: ''
    },
    jobCustomFieldI18nKey: {
      type: String,
      default: ''
    },
    showButtonSettings: {
      type: Boolean,
      default: false
    },
    buttonSwitchKey: {
      type: String,
      default: 'show'
    },
    buttonTitleI18nKey: {
      type: String,
      default: ''
    },
    buttonSettingI18nKey: {
      type: String,
      default: ''
    }
  },
  components: {
    WechatShareSetting,
    PageSettings,
    CustomJobFilter,
    CustomPageButtonSettings
  },
  data () {
    return {
      showDeviceTabs: true,
      i18nPrefix: 'admin.company.customLandingPage'
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    async submit () {
      let valid = true
      if (this.$refs.pageSettings) {
        valid = await this.$refs.pageSettings?.submit()
      }
      if (valid) {
        const customSetting = this.customSetting
        await this.$refs.jobFilter?.submit()
        if (customSetting.show_wechat_share_settings) {
          const wechatShareSettings = this.$refs.wechatShareSettings?.submit()
          customSetting.wechat_share_settings.wechat_share_config = wechatShareSettings
        }
      }
      return valid
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-landing-page-content {
  width: 680px;
  margin: 0 auto;
}
</style>
